import { Pipe, PipeTransform,Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';


@Pipe({name: 'objFilter',pure:false})
export class ObjectFilterPipe implements PipeTransform{

    constructor(private authService: AuthService){
        
    }

    transform(items,obj){
        return _.filter(items,(i) => {
            return _.every(_.keysIn(obj),(k) => {
                return obj[k] === i[k]
            })
        })
    }
}